import {
  FETCH_WALLET_REPORT_FAILED,
  FETCH_WALLET_REPORT_START,
  FETCH_WALLET_REPORT_SUCCESS,
  FETCH_DEPOSIT_WALLETS_START,
  FETCH_DEPOSIT_WALLETS_FAILED,
  FETCH_DEPOSIT_WALLETS_SUCCESS,
  REQUEST_WALLET_FX_TRANSFER_ERROR,
  REQUEST_WALLET_FX_TRANSFER_START,
  REQUEST_WALLET_FX_TRANSFER_SUCCESS,
  FETCH_DEPOSITS_START,
  FETCH_DEPOSITS_SUCCESS,
  FETCH_DEPOSITS_FAILED,
  FETCH_WITHDRAWALS_START,
  FETCH_WITHDRAWALS_SUCCESS,
  FETCH_WITHDRAWALS_FAILED,

} from './actionTypes'

export const fetchDepositWallets = (params = {}) => {
  return {
    type: FETCH_DEPOSIT_WALLETS_START,
    payload: params,
  }
}
export const fetchDepositWalletsFailed = (error) => {
  return {
    type: FETCH_DEPOSIT_WALLETS_FAILED,
    payload: error,
  }
}
export const fetchDepositWalletsSuccess = (params) => {
  return {
    type: FETCH_DEPOSIT_WALLETS_SUCCESS,
    payload: params,
  }
}

export const fetchHTXDeposits = (params = {}) => {
  return {
    type: FETCH_DEPOSITS_START,
    payload: params,
  }
}

export const fetchHTXDepositsSuccess = (params) => {
  return {
    type: FETCH_DEPOSITS_SUCCESS,
    payload: params,
  }
}

export const fetchHTXDepositsFailed = (error) => {
  return {
    type: FETCH_DEPOSITS_FAILED,
    payload: error,
  }
}

export const fetchHTXWithdrawals = (params = {}) => {
  return {
    type: FETCH_WITHDRAWALS_START,
    payload: params,
  }
}

export const fetchHTXWithdrawalsSuccess = (params) => {
  return {
    type: FETCH_WITHDRAWALS_SUCCESS,
    payload: params,
  }
}

export const fetchHTXWithdrawalsFailed = (error) => {
  return {
    type: FETCH_WITHDRAWALS_FAILED,
    payload: error,
  }
}

// export const createWalletTransfer = (data) => {
//   return {
//     type: REQUEST_WALLET_FX_TRANSFER_START,
//     payload: data,
//   }
// }

// export const createWalletTransferSuccess = (data) => {
//   return {
//     type: REQUEST_WALLET_FX_TRANSFER_SUCCESS,
//     payload: data,
//   }
// }

// export const createWalletTransferError = (error) => {
//   return {
//     type: REQUEST_WALLET_FX_TRANSFER_ERROR,
//     payload: error,
//   }
// }

// export const fetchReport = (params = {}) => {
//   return {
//     type: FETCH_WALLET_REPORT_START,
//     payload: params,
//   }
// }

// export const fetchReportSuccess = (params) => {
//   return {
//     type: FETCH_WALLET_REPORT_SUCCESS,
//     payload: params,
//   }
// }

// export const fetchReportFailed = (error) => {
//   return {
//     type: FETCH_WALLET_REPORT_FAILED,
//     payload: error,
//   }
// }
